// Custom Auction JavaScript

// Function to detect if an item is from the Vault Collection (buy-it-now)
function detectVaultCollection(wkAuction) {
    if (!wkAuction) return false;
    
    // Method 1: Check if there's a swau-vault container on the page AND this wkAuction has no auction elements
    const vaultContainer = document.querySelector('#swau-vault');
    if (vaultContainer) {
        // If swau-vault exists, check if this wkAuction has auction elements
        const hasAuctionTimer = wkAuction.querySelector('[id^="auction_"]');
        const hasBidCount = wkAuction.querySelector('.wk-bid-count');
        const hasEndDate = wkAuction.querySelector('.end_date_div');
        const hasCurrentBid = wkAuction.querySelector('.wk-current-bid');
        const hasMinBid = wkAuction.querySelector('.min_bid_amt');
        
        // If there are NO auction elements, it's a vault item
        if (!hasAuctionTimer && !hasBidCount && !hasEndDate && !hasCurrentBid && !hasMinBid) {
            return true;
        }
    }
    
    // Method 2: Check for vault tag (Liquid template approach)
    const hasVaultTag = wkAuction.getAttribute('data-vault-tag') === 'true' || 
                       wkAuction.querySelector('[data-vault-tag="true"]') !== null;
    if (hasVaultTag) {
        return true;
    }
    
    // Method 3: Check for specific data attributes that might indicate vault collection
    const productId = wkAuction.getAttribute('prod-id');
    const dataVault = wkAuction.getAttribute('data-vault');
    const dataCollection = wkAuction.getAttribute('data-collection');
    
    // Check if it's explicitly marked as vault collection
    if (dataVault === 'true' || dataCollection === 'vault') {
        return true;
    }
    
    // Method 4: Check for specific product IDs that are known vault items
    const vaultProductIds = [
        // Add specific product IDs for vault collection items here
        // Example: '1234567890', '0987654321'
    ];
    
    if (productId && vaultProductIds.includes(productId)) {
        return true;
    }
    
    // Method 5: Check for absence of auction-specific elements (fallback)
    const hasAuctionTimer = wkAuction.querySelector('[id^="auction_"]');
    const hasBidCount = wkAuction.querySelector('.wk-bid-count');
    const hasEndDate = wkAuction.querySelector('.end_date_div');
    const hasCurrentBid = wkAuction.querySelector('.wk-current-bid');
    const hasMinBid = wkAuction.querySelector('.min_bid_amt');
    
    // If there are NO auction elements at all, it's likely a vault collection item
    if (!hasAuctionTimer && !hasBidCount && !hasEndDate && !hasCurrentBid && !hasMinBid) {
        return true;
    }
    
    // Method 6: Check for vault-specific elements or text
    const vaultIndicators = [
        'vault',
        'buy it now',
        'buy-it-now',
        'immediate purchase',
        'available now'
    ];
    
    const auctionText = wkAuction.textContent.toLowerCase();
    const hasVaultText = vaultIndicators.some(indicator => auctionText.includes(indicator));
    
    if (hasVaultText) {
        return true;
    }
    
    return false;
}

function initializeCustomAuction(wkAuction) {
    // Comment out all 'Custom Auction' console logs
    // console.log('[Custom Auction] initializeCustomAuction called');
    
    // Check if this is a Vault Collection item (buy-it-now)
    const isVaultCollection = detectVaultCollection(wkAuction);
    
    // Debug logging
    console.log('[Custom Auction] Detection result:', {
        isVaultCollection: isVaultCollection,
        wkAuctionId: wkAuction.id,
        prodId: wkAuction.getAttribute('prod-id'),
        hasAuctionElements: !!wkAuction.querySelector('[id^="auction_"]'),
        hasVaultContainer: !!document.querySelector('#swau-vault'),
        hasAuctionContainer: !!document.querySelector('#swau-auction')
    });
    
    // Determine which container to use
    const containerId = isVaultCollection ? 'swau-vault' : 'swau-auction';
    const customContainer = document.querySelector(`#${containerId}`);
    
    if (!customContainer) {
        console.error(`Custom ${isVaultCollection ? 'vault' : 'auction'} container not found: #${containerId}`);
        return;
    }
    
    console.log('[Custom Auction] Using container:', containerId);

    // First, just show the loading state
    customContainer.innerHTML = `
        <div class="swau-loading-state">
            <div class="swau-loading-spinner"></div>
        </div>
    `;

    // Then after a short delay, inject the appropriate template
    setTimeout(() => {
        if (isVaultCollection) {
            // Vault Collection (Buy It Now) template
            customContainer.innerHTML = `
                <div class="swau-loading-state">
                    <div class="swau-loading-spinner"></div>
                </div>
                <section class="swau-vault-details" style="display:none;">
                    <div class="swau-vault-price-row">
                        <div class="swau-vault-price">
                            <div class="swau-vault-label">PRICE</div>
                            <div class="swau-vault-value" id="vault_price"></div>
                        </div>
                    </div>
                    <hr class="swau-vault-divider" />
                    <div class="swau-vault-description">
                        <span>Available for immediate purchase</span>
                    </div>
                </section>
                <section class="swau-vault-purchase-section" style="display:none;">
                    <button type="button" id="buy_now_button" class="swau-buy-now-button">
                        Buy It Now
                    </button>
                    <div class="swau-vault-info">
                        <p>Limited availability from the SWAU Vault</p>
                    </div>
                </section>
            `;
        } else {
            // Regular auction template
            customContainer.innerHTML = `
            <div class="swau-loading-state">
                <div class="swau-loading-spinner"></div>
            </div>
            <div id="status-banner" class="swau-status-banner" style="display:none;">
                <span class="swau-status-text"></span>
            </div>
            <section class="swau-auction-details" style="display:none;">
                <div class="swau-bid-stats-row">
                    <div class="swau-bid-stat">
                        <div class="swau-bid-label">CURRENT BID</div>
                        <div class="swau-bid-value" id="current_bid"></div>
                    </div>
                    <div class="swau-bid-stat">
                        <div class="swau-bid-label">BIDS</div>
                        <div class="swau-bid-value" id="show_bids"></div>
                    </div>
                </div>
                <div class="swau-reserve-status">
                    <span class="swau-status-message swau-reserve-price-not-met-msg">Reserve Price Not Met</span>
                    <span class="swau-status-message swau-reserve-price-met-msg" style="display: none;">Reserve Price Met</span>
                </div>
                <hr class="swau-auction-divider" />
                <div class="swau-auction-timer-ebay" id="auction-timer"></div>
            </section>
            <section class="swau-bidding-section" style="display:none;">
                <form id="bidding-form" class="swau-bid-form">
                    <div class="swau-bid-input-group">
                        <div class="swau-bid-input-wrapper">
                            <span class="swau-input-prefix">$</span>
                            <input type="text" id="bid_amount" class="swau-bid-input" placeholder="0" value="">
                        </div>
                        <button type="button" id="place_my_bid" class="swau-bid-button wk_submit_bid">
                            Place Bid
                        </button>
                    </div>
                    <div class="swau-bid-labels">
                        <label id="label_bid_amt" class="swau-min-bid"></label>
                    </div>
                </form>
                <!-- Hidden Fields -->
                <input type="hidden" id="auction_id" value="">
                <input type="hidden" id="min_bid_amount" value="">
                <input type="hidden" id="max_bid_amount" value="">
                <input type="hidden" id="reserve_price" value="">
            </section>
            <!-- Custom Confirmation Modal -->
            <div class="swau-modal" id="pa_confirm_bid_modal">
                <div class="swau-modal-content">
                    <div class="swau-modal-header">
                        <span>Confirm Your Bid</span>
                        <button class="swau-close-button" type="button" aria-label="Close">&times;</button>
                    </div>
                    <div class="swau-modal-body">
                        <p class="swau-confirm-message"></p>
                    </div>
                    <div class="swau-modal-actions">
                        <button type="button" class="swau-confirm-button">Confirm Bid</button>
                        <p class="swau-commitment-text">By selecting Confirm Bid, you are committing to buy this item if you are the winning bidder. Additional <a href="https://auction.swau.com/pages/rules" target="_blank">fees and taxes</a> may apply.</p>
                    </div>
                </div>
            </div>
        `;
        }

        // Get references to all required elements
        const loadingState = customContainer.querySelector('.swau-loading-state');
        
        if (isVaultCollection) {
            // Vault Collection specific elements
            const vaultDetails = customContainer.querySelector('.swau-vault-details');
            const vaultPurchaseSection = customContainer.querySelector('.swau-vault-purchase-section');
            const buyNowButton = customContainer.querySelector('#buy_now_button');
            const vaultPrice = customContainer.querySelector('#vault_price');

            // Function to show the vault content
            function showVaultContent() {
                if (loadingState) loadingState.style.display = 'none';
                if (vaultDetails) vaultDetails.style.display = '';
                if (vaultPurchaseSection) vaultPurchaseSection.style.display = '';
            }

            // Extract price from Webkul auction element
            const extractVaultPrice = () => {
                // Debug logging for vault price extraction
                console.log('[Vault] Starting price extraction...');
                
                // First, check for the data-vault-price attribute on the vault container
                const vaultContainer = document.querySelector('#swau-vault');
                const vaultPriceFromContainer = vaultContainer ? vaultContainer.getAttribute('data-vault-price') : null;
                console.log('[Vault] Vault container price:', vaultPriceFromContainer);
                
                if (vaultPriceFromContainer) {
                    const formattedPrice = formatPrice(vaultPriceFromContainer);
                    console.log('[Vault] Using vault container price:', formattedPrice);
                    return formattedPrice;
                }
                
                // Second, check for the data-vault-price attribute on the wk-auction container
                const vaultPrice = wkAuction.getAttribute('data-vault-price');
                console.log('[Vault] WK auction price:', vaultPrice);
                
                if (vaultPrice) {
                    const formattedPrice = formatPrice(vaultPrice);
                    console.log('[Vault] Using WK auction price:', formattedPrice);
                    return formattedPrice;
                }
                
                console.log('[Vault] No data-vault-price found, checking CSS selectors...');
                
                // For vault items, look for price in the product container itself
                // since there's no auction data
                const priceSelectors = [
                    '.product-price',
                    '.price',
                    '.current-price',
                    '.regular-price',
                    '.sale-price',
                    '.money',
                    '[data-price]',
                    '.wk-current-bid', // fallback
                    '.pa-text-color' // fallback
                ];
                
                for (const selector of priceSelectors) {
                    const priceElem = wkAuction.querySelector(selector);
                    if (priceElem && priceElem.textContent.trim()) {
                        const priceText = priceElem.textContent.trim();
                        console.log('[Vault] Found price in selector', selector, ':', priceText);
                        // Extract numeric value
                        const match = priceText.match(/[\d,]+\.?\d*/);
                        if (match) {
                            const formattedPrice = formatPrice(match[0]);
                            console.log('[Vault] Using CSS selector price:', formattedPrice);
                            return formattedPrice;
                        }
                    }
                }
                
                // If no price found in the container, try to get it from data attributes
                const dataPrice = wkAuction.getAttribute('data-price') || 
                                wkAuction.getAttribute('data-product-price') ||
                                wkAuction.querySelector('[data-price]')?.getAttribute('data-price');
                
                if (dataPrice) {
                    const formattedPrice = formatPrice(dataPrice);
                    console.log('[Vault] Using data attribute price:', formattedPrice);
                    return formattedPrice;
                }
                
                console.log('[Vault] No price found, using fallback $0.00');
                // Fallback price
                return '$0.00';
            };

            // Function to format numbers with commas
            function formatPrice(price) {
                // Remove any non-numeric characters except decimal point
                const numericPrice = price.toString().replace(/[^\d.]/g, '');
                // Split into dollars and cents
                const [dollars, cents] = numericPrice.split('.');
                // Format dollars with commas
                const formattedDollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                // Return with $ prefix and cents only if they exist and are not .00
                if (cents && cents !== '00') {
                    return `$${formattedDollars}.${cents}`;
                } else {
                    return `$${formattedDollars}`;
                }
            }

            // Set the price
            if (vaultPrice) {
                vaultPrice.textContent = extractVaultPrice();
            }

            // Handle buy now button click
            if (buyNowButton) {
                buyNowButton.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Check if user is logged in
                    const customerId = wkAuction.getAttribute('cust-id');
                    if (!customerId) {
                        // User is not logged in, redirect to login page
                        const currentUrl = encodeURIComponent(window.location.href);
                        window.location.href = `https://auction.swau.com/account/login?checkout_url=${currentUrl}`;
                        return;
                    }
                    
                    // Get the variant ID from the vault container
                    const vaultContainer = document.querySelector('#swau-vault');
                    const variantId = vaultContainer ? vaultContainer.getAttribute('variant-id') : null;
                    
                    if (!variantId) {
                        console.error('[Vault] No variant ID found on swau-vault div');
                        alert('Product information not available. Please refresh the page and try again.');
                        return;
                    }
                    
                    console.log('[Vault] Attempting to add item to cart with variant ID:', variantId);
                    
                    // Show loading state
                    buyNowButton.disabled = true;
                    buyNowButton.textContent = 'Adding to Cart...';
                    
                    // First, check if the item is already in the cart and clear it
                    fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                        // Check if this variant is already in the cart
                        const existingItem = cart.items.find(item => item.variant_id === parseInt(variantId));
                        
                        if (existingItem) {
                            console.log('[Vault] Item already in cart, clearing cart first');
                            // Clear the entire cart
                            return fetch('/cart/clear.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-Requested-With': 'XMLHttpRequest'
                                }
                            });
                        } else {
                            // Item not in cart, proceed directly to add
                            return Promise.resolve();
                        }
                    })
                    .then(() => {
                        // Now add the item to cart
                        return fetch('/cart/add.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Requested-With': 'XMLHttpRequest'
                            },
                            body: JSON.stringify({
                                id: parseInt(variantId),
                                quantity: 1
                            })
                        });
                    })
                    .then(response => {
                        console.log('[Vault] Cart API response status:', response.status);
                        if (!response.ok) {
                            return response.text().then(text => {
                                console.error('[Vault] Cart API error response:', text);
                                throw new Error(`Cart API error: ${response.status} - ${text}`);
                            });
                        }
                        return response.json();
                    })
                    .then(data => {
                        console.log('[Vault] Item added to cart successfully:', data);
                        // Redirect to checkout
                        window.location.href = '/checkout';
                    })
                    .catch(error => {
                        console.error('[Vault] Error adding item to cart:', error);
                        // Reset button state
                        buyNowButton.disabled = false;
                        buyNowButton.textContent = 'Buy It Now';
                        // Show error message
                        alert('Failed to add item to cart. Please try again or contact support.');
                    });
                });
            }

            // Show the vault content
            showVaultContent();
            
        } else {
            // Regular auction elements
            const bidForm = customContainer.querySelector('#bidding-form');
            const bidInput = customContainer.querySelector('#bid_amount');
            let placeBidButton = customContainer.querySelector('#place_my_bid');
            const customModal = customContainer.querySelector('#pa_confirm_bid_modal');
        const confirmBtn = customModal?.querySelector('.swau-confirm-button');
        const closeBtn = customModal?.querySelector('.swau-close-button');
            const auctionDetails = customContainer.querySelector('.swau-auction-details');
            const biddingSection = customContainer.querySelector('.swau-bidding-section');

        // Function to show the auction content
        function showAuctionContent() {
            if (loadingState) loadingState.style.display = 'none';
            if (auctionDetails) auctionDetails.style.display = '';
            if (biddingSection) biddingSection.style.display = '';
        }

        // Ensure modal is properly initialized
        if (!customModal) {
            // console.error('[Custom Auction] Modal container not found');
            return;
        }

        if (!confirmBtn) {
            // console.error('[Custom Auction] Confirm button not found in modal. Modal HTML:', customModal.innerHTML);
            return;
        }

        if (placeBidButton && customModal && confirmBtn) {
            // console.log('[Custom Auction] All modal elements found, setting up event listeners');
            
            // Remove any existing click handlers from the place bid button
            const newPlaceBidButton = placeBidButton.cloneNode(true);
            placeBidButton.parentNode.replaceChild(newPlaceBidButton, placeBidButton);
            placeBidButton = newPlaceBidButton; // Update the reference to the new button
            
            placeBidButton.addEventListener('click', function(e) {
                // console.log('[Custom Auction] Place Bid button clicked');
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                // Check if user is logged in
                const customerId = wkAuction.getAttribute('cust-id');
                if (!customerId) {
                    // User is not logged in, redirect to login page
                    const currentUrl = encodeURIComponent(window.location.href);
                    window.location.href = `https://auction.swau.com/account/login?checkout_url=${currentUrl}`;
                    return;
                }
                
                // Get the bid amount
                const bidAmount = bidInput.value;
                
                const confirmMessage = customModal.querySelector('.swau-confirm-message');
                if (confirmMessage) {
                    confirmMessage.textContent = `Are you sure you want to place a max bid of $${bidAmount}?`;
                }
                
                // Show our custom modal
                openBidModal();
            });

            confirmBtn.addEventListener('click', function(e) {
                // console.log('[Custom Auction] Confirm button clicked');
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                // Hide our modal first
                closeBidModal();
                
                // Show loading state on the Place Bid button
                placeBidButton.classList.add('loading');
                placeBidButton.disabled = true;
                const originalText = placeBidButton.textContent;
                placeBidButton.innerHTML = '<span class="spinner"></span>';
                
                // Get the bid amount
                const bidAmount = bidInput.value;
                
                // Track the user's bid amount for outbid detection
                userLastBidAmount = parseFloat(bidAmount);
                userHasPlacedBid = true;
                
                // Check if normal_as_proxy_config is enabled
                const normalAsProxyConfig = wkAuction.querySelector('#normal_as_proxy_config')?.value === '1';
                
                if (normalAsProxyConfig) {
                    // When normal_as_proxy_config is enabled, we need to set the bid amount in the Webkul form
                    const wkBidInput = wkAuction.querySelector('#bid_amount');
                    if (wkBidInput) {
                        wkBidInput.value = bidAmount;
                    }
                    const wkBidHidden = wkAuction.querySelector('#bid_amount_hidden');
                    if (wkBidHidden) {
                        wkBidHidden.value = bidAmount;
                    }
                    
                    // Also set the proxy bid amount if the field exists
                    const wkProxyBidInput = wkAuction.querySelector('#proxy_bid_amount');
                    if (wkProxyBidInput) {
                        wkProxyBidInput.value = bidAmount;
                    }
                    
                    // Set the normal_as_proxy flag to ensure it's treated as a proxy bid
                    const wkNormalAsProxy = wkAuction.querySelector('#normal_as_proxy');
                    if (wkNormalAsProxy) {
                        wkNormalAsProxy.value = '1';
                    }
                }
                
                // Click the Webkul submit bid button
                const wkSubmitBidModal = wkAuction.querySelector('.pa-submit-bid-modal');
                if (wkSubmitBidModal) {
                    wkSubmitBidModal.click();
                    
                    // Wait for the proxy confirmation modal and click the confirm button
                    let attempts = 0;
                    const maxAttempts = 40; // 2 seconds
                    const pollInterval = setInterval(() => {
                        const proxyModal = wkAuction.querySelector('#pa_proxy_confirmation');
                        const proxyBtn = wkAuction.querySelector('#confirm_proxy');
                        if (proxyModal && proxyBtn && proxyModal.style.display !== 'none' && window.getComputedStyle(proxyModal).display !== 'none') {
                            proxyBtn.click();
                            clearInterval(pollInterval);
                            // Reset button state after a short delay
                            setTimeout(() => {
                                placeBidButton.classList.remove('loading');
                                placeBidButton.disabled = false;
                                placeBidButton.textContent = originalText;
                                
                                // Trigger multiple bid status updates to catch immediate outbid scenarios
                                setTimeout(() => {
                                    updateBidStatus();
                                }, 200);
                                setTimeout(() => {
                                    updateBidStatus();
                                }, 500);
                                setTimeout(() => {
                                    updateBidStatus();
                                }, 1000);
                                setTimeout(() => {
                                    updateBidStatus();
                                }, 2000);
                            }, 1000);
                        }
                        attempts++;
                        if (attempts > maxAttempts) {
                            clearInterval(pollInterval);
                            // console.error('[Custom Auction] Timed out waiting for Webkul proxy modal to appear.');
                            // Reset button state on timeout
                            placeBidButton.classList.remove('loading');
                            placeBidButton.disabled = false;
                            placeBidButton.textContent = originalText;
                        }
                    }, 50);
                } else {
                    // console.error('[Custom Auction] Could not find Webkul submit bid modal button');
                    // Reset button state on error
                    placeBidButton.classList.remove('loading');
                    placeBidButton.disabled = false;
                    placeBidButton.textContent = originalText;
                }
            });

            if (closeBtn) {
                closeBtn.addEventListener('click', function(e) {
                    // console.log('[Custom Auction] Close button clicked');
                    e.preventDefault();
                    e.stopPropagation();
                    closeBidModal();
                });
            }

            // Close modal when clicking outside
            customModal.addEventListener('click', function(e) {
                if (e.target === customModal) {
                    // console.log('[Custom Auction] Clicked outside modal');
                    closeBidModal();
                }
            });
        } else {
            // console.error('[Custom Auction] Missing required elements for modal:', {
            //     placeBidButton: !!placeBidButton,
            //     customModal: !!customModal,
            //     confirmBtn: !!confirmBtn
            // });
        }

        // Copy Webkul data to our custom auction
            customContainer.setAttribute('prod-id', wkAuction.getAttribute('prod-id'));
            customContainer.setAttribute('cust-id', wkAuction.getAttribute('cust-id'));

        // Function to format numbers with commas
        function formatPrice(price) {
            // Remove any non-numeric characters except decimal point
            const numericPrice = price.toString().replace(/[^\d.]/g, '');
            // Split into dollars and cents
            const [dollars, cents] = numericPrice.split('.');
            // Format dollars with commas
            const formattedDollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                // Return with $ prefix and cents only if they exist and are not .00
                if (cents && cents !== '00') {
                    return `$${formattedDollars}.${cents}`;
                } else {
                    return `$${formattedDollars}`;
                }
        }

        // Update current bid
            const currentBidDisplay = customContainer.querySelector('#current_bid');
        const wkCurrentBid = wkAuction.querySelector('#current_bid');
        if (currentBidDisplay && wkCurrentBid) {
            // Remove spaces and format the bid amount
            let bidText = wkCurrentBid.textContent.replace(/\s+/g, '');
            bidText = bidText.replace(/\(You\)/i, '').replace(/\(Outbid\)/i, '').trim();
            currentBidDisplay.textContent = formatPrice(bidText);
        }

        // Update bid count
            const showBids = customContainer.querySelector('#show_bids');
        const wkShowBids = wkAuction.querySelector('#show_bids');
        if (showBids && wkShowBids) {
            // Extract just the number from the text
            const match = wkShowBids.textContent.match(/\d+/);
            const bidCount = match ? match[0] : '0';
            showBids.textContent = bidCount;

            // Update the CURRENT BID label to STARTING BID if there are no bids
                const bidLabel = customContainer.querySelector('.swau-bid-label');
            if (bidLabel && bidCount === '0') {
                bidLabel.textContent = 'STARTING BID';
            } else if (bidLabel) {
                bidLabel.textContent = 'CURRENT BID';
            }
        }

        // --- Prevent bid input overwrite while user is typing ---
        let userInteractedWithBidInput = false;
        let lastAutoSetBidValue = '';
        let userLastBidAmount = 0; // Track user's last bid amount
        let userHasPlacedBid = false; // Track if user has placed a bid in this session
        if (bidInput) {
            bidInput.addEventListener('focus', () => { userInteractedWithBidInput = true; });
            bidInput.addEventListener('input', () => { userInteractedWithBidInput = true; });
        }
        function setBidInputValueIfAllowed(newValue) {
            if (!userInteractedWithBidInput || bidInput.value === lastAutoSetBidValue) {
                bidInput.value = newValue;
                lastAutoSetBidValue = newValue;
            }
        }

        // Update minimum bid
        const wkMinBid = wkAuction.querySelector('.min_bid_amt');
        const wkProxyBid = wkAuction.querySelector('#display_proxy_bid_amount');
        let minBidValue = '';
        if (bidInput && wkMinBid) {
            // Default: use min_bid_amt from Webkul
            const minBidValueMatch = wkMinBid.textContent.match(/\d+(?:\.\d+)?/);
            minBidValue = minBidValueMatch ? minBidValueMatch[0] : '';

            // If proxy bid > current bid, set min bid to proxy bid + 1
            if (wkProxyBid && wkProxyBid.textContent.trim() && wkCurrentBid && wkCurrentBid.textContent.trim()) {
                const proxyBidNum = parseFloat(wkProxyBid.textContent.replace(/[^\d.]/g, ''));
                const currentBidNum = parseFloat(wkCurrentBid.textContent.replace(/[^\d.]/g, ''));
                if (!isNaN(proxyBidNum) && !isNaN(currentBidNum) && proxyBidNum > currentBidNum) {
                    minBidValue = (proxyBidNum + 1).toFixed(2).replace(/\.00$/, '');
                }
            }

                const bidLabel = customContainer.querySelector('#label_bid_amt');
            if (bidLabel) {
                bidLabel.textContent = `Bid ${formatPrice(minBidValue)} or more.`;
            }
                const minBidHidden = customContainer.querySelector('#min_bid_amount');
            if (minBidHidden) {
                minBidHidden.value = minBidValue;
            }
            // Only set the bid input value if the user hasn't interacted or if min bid changed
            setBidInputValueIfAllowed(minBidValue);
            // Reset user interaction if min bid changed
            if (minBidValue !== lastAutoSetBidValue) {
                userInteractedWithBidInput = false;
            }
        }

        // Copy hidden fields from Webkul
        const hiddenFields = {
            'auction_id': wkAuction.querySelector('#auction_id')?.value || '',
            'max_bid_amount': wkAuction.querySelector('#max_bid_amount')?.value || '0',
            'reserve_price': wkAuction.querySelector('#reserve_price')?.value || '0'
        };

        Object.entries(hiddenFields).forEach(([id, value]) => {
                const field = customContainer.querySelector(`#${id}`);
            if (field) {
                field.value = value;
            }
        });

        // Initialize variables
            const minBidAmount = parseFloat(customContainer.querySelector('#min_bid_amount').value);
            const maxBidAmount = parseFloat(customContainer.querySelector('#max_bid_amount').value);
            const reservePrice = parseFloat(customContainer.querySelector('#reserve_price').value);

        // Show reserve price status if applicable (based on Webkul visibility, not #reserve_price)
            const reserveStatus = customContainer.querySelector('.swau-reserve-status');
        const wkReserveMet = wkAuction.querySelector('.reserve-price-met-msg');
        const wkReserveNotMet = wkAuction.querySelector('.reserve-price-not-met-msg');
        function isVisible(el) {
            return el && el.offsetParent !== null;
        }
        if (reserveStatus) {
            if (isVisible(wkReserveMet) || isVisible(wkReserveNotMet)) {
                reserveStatus.style.display = '';
                const metMsg = reserveStatus.querySelector('.swau-reserve-price-met-msg');
                const notMetMsg = reserveStatus.querySelector('.swau-reserve-price-not-met-msg');
                if (isVisible(wkReserveMet)) {
                    if (metMsg) metMsg.style.display = '';
                    if (notMetMsg) notMetMsg.style.display = 'none';
                } else if (isVisible(wkReserveNotMet)) {
                    if (metMsg) metMsg.style.display = 'none';
                    if (notMetMsg) notMetMsg.style.display = '';
                } else {
                    if (metMsg) metMsg.style.display = 'none';
                    if (notMetMsg) notMetMsg.style.display = 'none';
                }
            } else {
                reserveStatus.style.display = 'none';
            }
        }

        // --- Begin: Extract auction ended date ---
        let endedDateText = '';
        // Look for the span with 'End Date:' (allow trailing spaces) and get the next .pa-text-color span
        let endDateLabel = Array.from(wkAuction.querySelectorAll('span')).find(
          span => span.textContent.trim().startsWith('End Date:')
        );
        if (endDateLabel) {
            let dateSpan = endDateLabel.nextElementSibling;
            if (dateSpan && dateSpan.classList.contains('pa-text-color')) {
                // Remove time if present (e.g., 'Jun 15, 2025 05:25 PM' -> 'Jun 15, 2025')
                endedDateText = dateSpan.textContent.trim().replace(/\s+\d{1,2}:\d{2}\s*[AP]M/i, '');
            }
        }
        // Fallbacks if not found
        if (!endedDateText) {
            let endedDateElem = wkAuction.querySelector('.ended_at_div .auction-ended-date') ||
                                wkAuction.querySelector('.auction_ended_at .auction-ended-date') ||
                                wkAuction.querySelector('.auction-ended-date');
            if (endedDateElem && endedDateElem.textContent.trim()) {
                // Remove time if present
                endedDateText = endedDateElem.textContent.trim().replace(/\s+\d{1,2}:\d{2}\s*[AP]M/i, '');
            } else {
                let endedAtContainer = wkAuction.querySelector('.ended_at_div') || wkAuction.querySelector('.auction_ended_at');
                if (endedAtContainer && endedAtContainer.textContent) {
                    // Match only the date part
                    const dateMatch = endedAtContainer.textContent.match(/([A-Z][a-z]+ \d{1,2}, \d{4})/);
                    if (dateMatch) endedDateText = dateMatch[1];
                }
            }
        }
        if (!endedDateText) {
            const today = new Date();
            endedDateText = today.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
        }
        // --- End: Extract auction ended date ---

        // Format endedDateText to use full month name if possible
        (function() {
            // Try to parse endedDateText and reformat
            const dateMatch = endedDateText.match(/([A-Za-z]+) (\d{1,2}), (\d{4})/);
            if (dateMatch) {
                // Try to parse as a date
                const parsedDate = new Date(`${dateMatch[1]} ${dateMatch[2]}, ${dateMatch[3]}`);
                if (!isNaN(parsedDate)) {
                    endedDateText = parsedDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
                }
            }
        })();

        // Initialize countdown timer
        let timerInterval = null;
        let currentEndDate = null;
        
        function initializeTimer(endedDateTextParam) {
            // Clear any existing timer interval first
            if (timerInterval) {
                clearInterval(timerInterval);
                timerInterval = null;
            }
            
            // Extract timer from Webkul
            const wkTimerInput = wkAuction.querySelector('#pa-timer-status');
                const timerDiv = customContainer.querySelector('#auction-timer');
            if (!wkTimerInput || !timerDiv) {
                timerDiv.textContent = endedDateTextParam ? `Auction Ended ${endedDateTextParam}` : 'Auction Ended';
                timerDiv.style.color = '';
                return;
            }
            // Parse the value (e.g., "01203631")
            const value = wkTimerInput.value;
            if (!/^[0-9]{8}$/.test(value)) {
                timerDiv.textContent = endedDateTextParam ? `Auction Ended ${endedDateTextParam}` : 'Auction Ended';
                timerDiv.style.color = '';
                return;
            }
            const days = parseInt(value.slice(0, 2), 10);
            const hours = parseInt(value.slice(2, 4), 10);
            const minutes = parseInt(value.slice(4, 6), 10);
            const seconds = parseInt(value.slice(6, 8), 10);

            // Calculate the end date from now
            const now = new Date();
            currentEndDate = new Date(now.getTime() +
                days * 24 * 60 * 60 * 1000 +
                hours * 60 * 60 * 1000 +
                minutes * 60 * 1000 +
                seconds * 1000
            );

            function pad(n) { return n < 10 ? '0' + n : n; }
            function formatEndTime(date) {
                const dayOfWeek = date.toLocaleString('en-US', { weekday: 'long' });
                let hours = date.getHours();
                const minutes = pad(date.getMinutes());
                const ampm = hours >= 12 ? 'PM' : 'AM';
                hours = hours % 12;
                hours = hours ? hours : 12;
                return `${dayOfWeek} at ${hours}:${minutes} ${ampm}`;
            }
            function updateTimer() {
                const now = new Date();
                const timeLeft = currentEndDate - now;
                if (timeLeft <= 0) {
                    clearInterval(timerInterval);
                    timerInterval = null;
                    timerDiv.textContent = endedDateTextParam ? `Auction Ended ${endedDateTextParam}` : 'Auction Ended';
                    timerDiv.style.color = '';
                    return;
                }
                const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
                let timeStr = '';
                
                if (days > 0) {
                    // Show days and hours only, plus end date
                    timeStr = `${days} ${days === 1 ? 'day' : 'days'} ${hours} ${hours === 1 ? 'hour' : 'hours'}`;
                    timerDiv.innerHTML = `<div class="timer-main">Ends in ${timeStr}</div><span class="timer-separator">&middot;</span><div class="timer-date">${formatEndTime(currentEndDate)}</div>`;
                    timerDiv.style.color = '';
                } else if (hours > 0) {
                    // Show hours and minutes
                    timeStr = `${hours} ${hours === 1 ? 'hour' : 'hours'} ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
                    timerDiv.innerHTML = `<div class="timer-main">Ends in ${timeStr}</div><span class="timer-separator">&middot;</span><div class="timer-date">${formatEndTime(currentEndDate)}</div>`;
                    timerDiv.style.color = '';
                } else {
                    // Show minutes and seconds only
                    timeStr = `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ${seconds} ${seconds === 1 ? 'second' : 'seconds'}`;
                    timerDiv.innerHTML = `<div class="timer-main">Ends in ${timeStr}</div>`;
                    timerDiv.style.color = 'red';
                }
            }
            updateTimer();
            timerInterval = setInterval(updateTimer, 1000);
        }
        
        // Function to update timer when extended bidding occurs
        function updateTimerForExtendedBidding() {
            const wkTimerInput = wkAuction.querySelector('#pa-timer-status');
            const timerDiv = customContainer.querySelector('#auction-timer');
            
            if (!wkTimerInput || !timerDiv) {
                return;
            }
            
            // Parse the new value (e.g., "01203631")
            const value = wkTimerInput.value;
            if (!/^[0-9]{8}$/.test(value)) {
                return;
            }
            
            const days = parseInt(value.slice(0, 2), 10);
            const hours = parseInt(value.slice(2, 4), 10);
            const minutes = parseInt(value.slice(4, 6), 10);
            const seconds = parseInt(value.slice(6, 8), 10);

            // Calculate the new end date from now
            const now = new Date();
            const newEndDate = new Date(now.getTime() +
                days * 24 * 60 * 60 * 1000 +
                hours * 60 * 60 * 1000 +
                minutes * 60 * 1000 +
                seconds * 1000
            );
            
            // Check if the end date has actually changed (extended bidding occurred)
            if (currentEndDate && newEndDate > currentEndDate) {
                const timeExtension = Math.round((newEndDate - currentEndDate) / (1000 * 60)); // minutes
                console.log(`[Custom Auction] Extended bidding detected - auction extended by ${timeExtension} minutes`);
                console.log(`[Custom Auction] Old end time: ${currentEndDate.toLocaleString()}`);
                console.log(`[Custom Auction] New end time: ${newEndDate.toLocaleString()}`);
                
                currentEndDate = newEndDate;
                
                // Clear the existing interval and restart the timer
                if (timerInterval) {
                    clearInterval(timerInterval);
                    timerInterval = null;
                }
                
                // Restart the timer with the new end date
                initializeTimer(endedDateText);
            }
        }
        
        initializeTimer(endedDateText);

        function showError(message) {
            if (!bidForm) return;
            const errorDiv = document.createElement('div');
            errorDiv.className = 'pa-username-text font-15 margin-btm-15 pa-pointer';
            errorDiv.textContent = message;
            bidForm.appendChild(errorDiv);
            setTimeout(() => errorDiv.remove(), 3000);
        }

        // Prevent form submission from triggering Webkul logic
        if (bidForm) {
            bidForm.addEventListener('submit', function(e) {
                e.preventDefault();
                e.stopPropagation();
            });
        }

        // Prevent Webkul's modal from showing
        const wkModal = document.querySelector('.pa-modal-content');
        if (wkModal) {
            wkModal.style.display = 'none';
            wkModal.classList.remove('active');
        }

        // Add observer to prevent Webkul's modal
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach((node) => {
                        if (node.classList && (node.classList.contains('pa-modal-content') || node.classList.contains('modal'))) {
                            node.style.display = 'none';
                            node.classList.remove('active');
                        }
                    });
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Set up observers for bid updates
        function updateBidStatus() {
            // Check for extended bidding and update timer if needed
            updateTimerForExtendedBidding();
            
                const currentBidDisplay = customContainer.querySelector('#current_bid');
            const wkCurrentBid = wkAuction.querySelector('#current_bid');
            const wkHighestBidder = wkAuction.querySelector('.customer_highest_bidder');
            const wkParticipated = wkAuction.querySelector('.customer_participated');
            const wkNotParticipated = wkAuction.querySelector('.customer_not_participated');
                const statusBanner = customContainer.querySelector('.swau-status-banner');
            const statusText = statusBanner ? statusBanner.querySelector('.swau-status-text') : null;
            
            if (currentBidDisplay && wkCurrentBid) {
                // Check if the original Webkul bid text contains "(Outbid)" indicator
                const originalBidText = wkCurrentBid.textContent;
                const hasOutbidIndicator = /\(Outbid\)/i.test(originalBidText);
                
                // Update current bid (remove any (You) or (Outbid) or similar text)
                let bidText = wkCurrentBid.textContent.replace(/\s+/g, '');
                bidText = bidText.replace(/\(You\)/i, '').replace(/\(Outbid\)/i, '').trim();
                currentBidDisplay.textContent = formatPrice(bidText);
                
                // Update bid count and label
                    const showBids = customContainer.querySelector('#show_bids');
                const wkShowBids = wkAuction.querySelector('#show_bids');
                if (showBids && wkShowBids) {
                    const match = wkShowBids.textContent.match(/\d+/);
                    const bidCount = match ? match[0] : '0';
                    showBids.textContent = bidCount;

                    // Update the CURRENT BID label to STARTING BID if there are no bids
                        const bidLabel = customContainer.querySelector('.swau-bid-label');
                    if (bidLabel && bidCount === '0') {
                        bidLabel.textContent = 'STARTING BID';
                    } else if (bidLabel) {
                        bidLabel.textContent = 'CURRENT BID';
                    }
                }
                
                // Track previous status to avoid unnecessary updates
                const prevStatus = statusBanner?.getAttribute('data-status');
                let newStatus = '';
                
                // Enhanced outbid detection logic
                if (wkHighestBidder) {
                    newStatus = 'highest';
                } else if (hasOutbidIndicator) {
                    // Direct indicator from Webkul that user has been outbid
                    newStatus = 'outbid';
                } else if (wkParticipated) {
                    // User has participated but is not the highest bidder
                    newStatus = 'outbid';
                } else if (userHasPlacedBid && userLastBidAmount > 0) {
                    // User has placed a bid in this session, check if current price is higher than their bid
                    const currentBidAmount = parseFloat(bidText.replace(/[^\d.]/g, ''));
                    
                    if (!isNaN(currentBidAmount) && currentBidAmount > userLastBidAmount) {
                        // Current price is higher than user's bid - they're outbid
                        newStatus = 'outbid';
                    } else {
                        // Don't clear the status if user is currently placing a bid (modal is open)
                        if (isModalOpen && prevStatus === 'outbid') {
                            newStatus = 'outbid'; // Keep the outbid status while modal is open
                        } else {
                            newStatus = 'none';
                        }
                    }
                } else {
                    newStatus = 'none';
                }

                // Get user's max proxy bid from Webkul
                let maxBid = '';
                const wkProxyBid = wkAuction.querySelector('#display_proxy_bid_amount');
                if (wkProxyBid && wkProxyBid.textContent.trim()) {
                    maxBid = wkProxyBid.textContent.trim().replace(/[^\d.]/g, '');
                }
                if (!maxBid) {
                    // If no proxy bid is displayed, use the current bid amount
                    maxBid = bidText.replace(/[^\d.]/g, '');
                }

                // Check if status or max bid has changed
                const prevMaxBid = statusBanner?.getAttribute('data-max-bid');
                const statusChanged = prevStatus !== newStatus;
                const maxBidChanged = prevMaxBid !== maxBid;

                if (statusBanner && (statusChanged || maxBidChanged)) {
                    if (newStatus === 'highest') {
                        statusBanner.style.display = '';
                        statusBanner.classList.remove('outbid');
                        statusBanner.classList.add('swau-status-banner');
                        statusBanner.style.background = 'linear-gradient(90deg, #24c755 0%, #1fa94a 100%)'; // green gradient
                        if (statusText) statusText.textContent = `You are the highest bidder! Your max bid is ${formatPrice(maxBid)}.`;
                        
                        // Reset user bid tracking when they become highest bidder
                        userLastBidAmount = 0;
                        userHasPlacedBid = false;
                    } else if (newStatus === 'outbid') {
                        statusBanner.style.display = '';
                        statusBanner.classList.remove('swau-status-banner');
                        statusBanner.classList.add('swau-status-banner', 'outbid');
                        statusBanner.style.background = 'linear-gradient(90deg, #FC005C 0%, #b8003c 100%)'; // red gradient
                        if (statusText) {
                            statusText.innerHTML = `You've been outbid. <a href="#" class="increase-bid-link">Increase your max bid</a>.`;
                            // Add click handler to the link
                            const link = statusText.querySelector('.increase-bid-link');
                            if (link) {
                                link.onclick = function(ev) {
                                    ev.preventDefault();
                                    // Trigger the Place Bid button click event
                                    if (placeBidButton) {
                                        placeBidButton.click();
                                    }
                                };
                            }
                        }
                    } else {
                        statusBanner.style.display = 'none';
                    }
                    statusBanner.setAttribute('data-status', newStatus);
                    statusBanner.setAttribute('data-max-bid', maxBid);
                }

                // Update bidder status classes
                if (newStatus === 'highest') {
                    currentBidDisplay.classList.add('customer_highest_bidder');
                    currentBidDisplay.classList.remove('customer_participated', 'customer_not_participated');
                } else if (newStatus === 'outbid') {
                    currentBidDisplay.classList.add('customer_participated');
                    currentBidDisplay.classList.remove('customer_highest_bidder', 'customer_not_participated');
                } else {
                    currentBidDisplay.classList.add('customer_not_participated');
                    currentBidDisplay.classList.remove('customer_highest_bidder', 'customer_participated');
                }
            }

            // Update minimum bid
            const wkMinBid = wkAuction.querySelector('.min_bid_amt');
            const wkProxyBid = wkAuction.querySelector('#display_proxy_bid_amount');
            let minBidValue = '';
            if (bidInput && wkMinBid) {
                // Default: use min_bid_amt from Webkul
                const minBidValueMatch = wkMinBid.textContent.match(/\d+(?:\.\d+)?/);
                minBidValue = minBidValueMatch ? minBidValueMatch[0] : '';

                // If proxy bid > current bid, set min bid to proxy bid + 1
                if (wkProxyBid && wkProxyBid.textContent.trim() && wkCurrentBid && wkCurrentBid.textContent.trim()) {
                    const proxyBidNum = parseFloat(wkProxyBid.textContent.replace(/[^\d.]/g, ''));
                    const currentBidNum = parseFloat(wkCurrentBid.textContent.replace(/[^\d.]/g, ''));
                    if (!isNaN(proxyBidNum) && !isNaN(currentBidNum) && proxyBidNum > currentBidNum) {
                        minBidValue = (proxyBidNum + 1).toFixed(2).replace(/\.00$/, '');
                    }
                }

                    const bidLabel = customContainer.querySelector('#label_bid_amt');
                if (bidLabel) {
                    bidLabel.textContent = `Bid ${formatPrice(minBidValue)} or more.`;
                }
                    const minBidHidden = customContainer.querySelector('#min_bid_amount');
                if (minBidHidden) {
                    minBidHidden.value = minBidValue;
                }
                // Only set the bid input value if the user hasn't interacted or if min bid changed
                setBidInputValueIfAllowed(minBidValue);
                // Reset user interaction if min bid changed
                if (minBidValue !== lastAutoSetBidValue) {
                    userInteractedWithBidInput = false;
                }
            }

            // Update reserve price status
                const reserveStatus = customContainer.querySelector('.swau-reserve-status');
            const wkReserveMet = wkAuction.querySelector('.reserve-price-met-msg');
            const wkReserveNotMet = wkAuction.querySelector('.reserve-price-not-met-msg');
            
            if (reserveStatus) {
                if (isVisible(wkReserveMet) || isVisible(wkReserveNotMet)) {
                    reserveStatus.style.display = '';
                    const metMsg = reserveStatus.querySelector('.swau-reserve-price-met-msg');
                    const notMetMsg = reserveStatus.querySelector('.swau-reserve-price-not-met-msg');
                    if (isVisible(wkReserveMet)) {
                        if (metMsg) metMsg.style.display = '';
                        if (notMetMsg) notMetMsg.style.display = 'none';
                    } else if (isVisible(wkReserveNotMet)) {
                        if (metMsg) metMsg.style.display = 'none';
                        if (notMetMsg) notMetMsg.style.display = '';
                    }
                } else {
                    reserveStatus.style.display = 'none';
                }
            }
        }

        // Set up mutation observer for bid updates
        const bidObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList' || mutation.type === 'characterData') {
                    updateBidStatus();
                }
            });
        });

        // Observe the Webkul auction container for changes
        bidObserver.observe(wkAuction, {
            childList: true,
            subtree: true,
            characterData: true
        });
        
        // Set up specific observer for timer changes (extended bidding)
        const timerObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                    // Timer value changed, check for extended bidding
                    updateTimerForExtendedBidding();
                }
            });
        });
        
        // Observe the timer input specifically for value changes
        const wkTimerInput = wkAuction.querySelector('#pa-timer-status');
        if (wkTimerInput) {
            timerObserver.observe(wkTimerInput, {
                attributes: true,
                attributeFilter: ['value']
            });
        }

        // Initial update
        updateBidStatus();
        
        // Set up periodic check for extended bidding (backup mechanism)
        setInterval(() => {
            updateTimerForExtendedBidding();
        }, 5000); // Check every 5 seconds

        // Show the auction content once we have the initial data
        showAuctionContent();

        // --- Begin: Robust support for ended auctions with final price (span or div) ---
        let finalPriceElem =
          wkAuction.querySelector('.ended_at_div .pa-text-color') ||
          wkAuction.querySelector('.auction_ended_at');
        // --- End: Robust support for ended auctions with final price ---

        // Use finalPriceElem from above in the initialization logic
        const finishedMsg = wkAuction.querySelector('.pa-finished-msg');
        if (
            (!wkAuction.querySelector('#current_bid') || !wkAuction.querySelector('#min_bid_amount')) &&
            finalPriceElem && finalPriceElem.textContent.trim()
        ) {
            // Auction is ended and only has a final price
            if (currentBidDisplay) {
                // Format the final price with commas
                let price = finalPriceElem.textContent.trim().replace(/[^\d.,]/g, '');
                currentBidDisplay.textContent = formatPrice(price);
                // Add 'Incl buyer's premium' under the price
                let inclPremium = document.createElement('div');
                inclPremium.className = 'swau-incl-premium';
                inclPremium.textContent = "Incl buyer's premium";
                currentBidDisplay.parentNode.appendChild(inclPremium);
            }
                const bidLabel = customContainer.querySelector('.swau-bid-label');
            if (bidLabel) {
                bidLabel.textContent = 'FINAL PRICE';
            }
            // Optionally, hide the bid input and button
                const biddingSection = customContainer.querySelector('.swau-bidding-section');
            if (biddingSection) {
                biddingSection.style.display = 'none';
            }
            // Hide the status banner for ended auctions
                const statusBanner = customContainer.querySelector('.swau-status-banner');
            if (statusBanner) {
                statusBanner.style.display = 'none';
            }
            // Update the in-body 'Auction Ended' text to include the end date
            if (finishedMsg && finishedMsg.textContent.trim()) {
                finishedMsg.textContent = `Auction Ended ${endedDateText}`;
            }
        }
        // --- End: Robust support for ended auctions with final price ---

        // --- Bid Increment Suggestions ---
        let lastRenderedMinBid = null;
        let isModalOpen = false;
        let lastMinBidValue = null;

        // Helper functions for bid increment suggestions
        function getBidIncrementRules() {
                const rulesInput = customContainer.querySelector('#bidding_rules') || wkAuction.querySelector('#bidding_rules');
            if (!rulesInput) return [];
            try {
                return JSON.parse(rulesInput.value);
            } catch (e) {
                console.error('Failed to parse bidding rules:', e);
                return [];
            }
        }
        function getIncrementForBid(bid, rules) {
            for (const rule of rules) {
                const from = parseFloat(rule.bid_from);
                const to = parseFloat(rule.bid_to);
                if (bid >= from && bid < to) {
                    return parseFloat(rule.rate);
                }
            }
            // Fallback: use the last rule's rate
            if (rules.length > 0) return parseFloat(rules[rules.length - 1].rate);
            return 1;
        }
        function getBidSuggestions(currentBid, rules, count = 3) {
            let suggestions = [];
            let bid = parseFloat(currentBid);
            const minIncrement = getIncrementForBid(bid, rules);
            for (let i = 0; i < count - 1; i++) {
                const increment = getIncrementForBid(bid, rules);
                bid += increment;
                let bidStr = bid.toFixed(2).replace(/\.00$/, '');
                suggestions.push(bidStr);
            }
            // --- Improved proxy encouragement logic for last suggestion ---
            let proxyEncourage = parseFloat(currentBid) + Math.max(minIncrement * 3, parseFloat(currentBid) * 0.10);
            // Always round up to the next increment for minBid
            proxyEncourage = Math.ceil(proxyEncourage / minIncrement) * minIncrement;
            // Ensure it's at least 2 increments above the previous suggestion
            let prev = parseFloat(suggestions[suggestions.length - 1]);
            if (proxyEncourage <= prev + minIncrement) {
                proxyEncourage = prev + minIncrement * 2;
                proxyEncourage = Math.ceil(proxyEncourage / minIncrement) * minIncrement;
            }
            let proxyBidStr = proxyEncourage.toFixed(2).replace(/\.00$/, '');
            suggestions.push(proxyBidStr);
            return suggestions;
        }

        // Listen for modal open/close to pause suggestions update
        if (customModal) {
            customModal.addEventListener('show', () => { isModalOpen = true; });
            customModal.addEventListener('hide', () => { isModalOpen = false; });
        }
        // Also set isModalOpen in the code that opens/closes the modal
        function openBidModal() {
            customModal.style.display = 'flex';
            customModal.classList.add('swau-active');
            isModalOpen = true;
        }
        function closeBidModal() {
            customModal.classList.remove('swau-active');
            customModal.style.display = 'none';
            isModalOpen = false;
        }

        // Render bid suggestions only if min bid changes and modal is not open
        function renderBidSuggestions() {
                const bidInputGroup = customContainer.querySelector('.swau-bid-input-group');
            if (!bidInputGroup) return;
                const minBid = parseFloat(customContainer.querySelector('#min_bid_amount')?.value || '0');
                if (minBid === lastRenderedMinBid && customContainer.querySelector('.swau-bid-suggestions') && !isModalOpen) return;
            if (isModalOpen) return;
            lastRenderedMinBid = minBid;
            // Remove old suggestions if present
                let old = customContainer.querySelector('.swau-bid-suggestions');
            if (old) old.remove();
            // Get current bid and rules
            const rules = getBidIncrementRules();
            if (!rules.length || isNaN(minBid)) return;
            const suggestions = getBidSuggestions(minBid, rules);
            // Create container
            const container = document.createElement('div');
            container.className = 'swau-bid-suggestions';
            container.style.display = 'flex';
            container.style.gap = '0.5rem';
            container.style.marginTop = '0.5rem';
            suggestions.forEach(s => {
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'swau-bid-suggestion-btn';
                btn.textContent = formatPrice(s);
                btn.style.padding = '0.4em 1.1em';
                btn.style.fontSize = '1rem';
                btn.style.borderRadius = '6px';
                btn.style.border = '1.5px solid #e5e7eb';
                btn.style.background = '#f8f9fa';
                btn.style.cursor = 'pointer';
                btn.style.transition = 'background 0.2s, border 0.2s';
                btn.onmouseenter = () => { btn.style.background = '#e5e7eb'; };
                btn.onmouseleave = () => { btn.style.background = '#f8f9fa'; };
                btn.onclick = () => {
                    bidInput.value = s;
                    bidInput.focus();
                    openBidModal();
                    // Set the confirm message to match the new value
                    const confirmMessage = customModal.querySelector('.swau-confirm-message');
                    if (confirmMessage) {
                        confirmMessage.textContent = `Are you sure you want to place a max bid of $${s}?`;
                    }
                };
                container.appendChild(btn);
            });
            bidInputGroup.parentNode.insertBefore(container, bidInputGroup.nextSibling);
        }

        // Only call renderBidSuggestions when min bid changes
        function checkAndRenderBidSuggestions() {
                const minBid = customContainer.querySelector('#min_bid_amount')?.value;
            if (minBid !== lastMinBidValue) {
                lastMinBidValue = minBid;
                renderBidSuggestions();
            }
        }

        // Initial render
        renderBidSuggestions();
        // Call checkAndRenderBidSuggestions after bid status updates
        const origUpdateBidStatus = updateBidStatus;
        updateBidStatus = function() {
            origUpdateBidStatus();
            checkAndRenderBidSuggestions();
        };

        // --- Custom Bid History Modal ---
        // Inject modal HTML into custom auction
        const bidHistoryModalId = 'swau-bid-history-modal';
        if (!document.getElementById(bidHistoryModalId)) {
            const modal = document.createElement('div');
            modal.id = bidHistoryModalId;
            modal.className = 'swau-modal';
            modal.innerHTML = `
                <div class="swau-modal-content" style="max-width:600px;min-width:320px;">
                    <div class="swau-modal-header" style="justify-content: space-between; align-items: center;">
                        <span>Bid History</span>
                        <button class="swau-close-button" type="button" aria-label="Close">&times;</button>
                    </div>
                    <div class="swau-modal-body">
                        <div class="swau-bid-history-table-wrapper">
                            <table class="swau-bid-history-table" style="width:100%;border-collapse:collapse;">
                                <thead>
                                    <tr>
                                        <th>Bidder</th>
                                        <th>Bid</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                </div>
            `;
            document.body.appendChild(modal);
        }
        const bidHistoryModal = document.getElementById(bidHistoryModalId);
        const closeBidHistoryBtn = bidHistoryModal.querySelector('.swau-close-button');
        closeBidHistoryBtn.onclick = () => {
            bidHistoryModal.style.display = 'none';
            bidHistoryModal.classList.remove('swau-active');
        };
        bidHistoryModal.addEventListener('click', function(e) {
            if (e.target === bidHistoryModal) {
                bidHistoryModal.style.display = 'none';
                bidHistoryModal.classList.remove('swau-active');
            }
        });
        // Show bid history modal and populate data
        function showBidHistoryModal() {
            // 1. Simulate a click on the Webkul bid count to trigger their modal
            const wkShowBids = document.querySelector('#wk-auction #show_bids');
            if (wkShowBids) wkShowBids.click();

            // 2. Wait for #bidders_list to appear and be populated
            let attempts = 0;
            const maxAttempts = 40; // 2 seconds
            const pollInterval = setInterval(() => {
                const wkBiddersList = document.getElementById('bidders_list');
                if (wkBiddersList && wkBiddersList.querySelector('tbody tr')) {
                    clearInterval(pollInterval);
                    // 3. Parse the table rows
                    const tableBody = bidHistoryModal.querySelector('tbody');
                    tableBody.innerHTML = '';
                    const rows = wkBiddersList.querySelectorAll('tbody tr');
                    rows.forEach(row => {
                        const cells = row.querySelectorAll('td');
                        if (cells.length === 3) {
                            // Remove space between $ and amount in Bid column
                            let bidText = cells[1].textContent.replace(/\$\s+/, '$');
                            const tr = document.createElement('tr');
                            tr.innerHTML = `
                                <td>${cells[0].textContent}</td>
                                <td>${bidText}</td>
                                <td>${cells[2].textContent}</td>
                            `;
                            tableBody.appendChild(tr);
                        }
                    });
                    // 4. Hide the Webkul modal
                    wkBiddersList.style.display = 'none';
                    // 5. Show our custom modal
                    bidHistoryModal.style.display = 'flex';
                    bidHistoryModal.classList.add('swau-active');
                } else if (attempts > maxAttempts) {
                    clearInterval(pollInterval);
                    // No data available
                    const tableBody = bidHistoryModal.querySelector('tbody');
                    tableBody.innerHTML = '';
                    const tr = document.createElement('tr');
                    tr.innerHTML = `<td colspan="3" style="text-align:center;">No bid history available.</td>`;
                    tableBody.appendChild(tr);
                    bidHistoryModal.style.display = 'flex';
                    bidHistoryModal.classList.add('swau-active');
                }
                attempts++;
            }, 50);
        }
        // Add click handler to custom #show_bids
            const customShowBids = customContainer.querySelector('#show_bids');
        if (customShowBids) {
            customShowBids.style.cursor = 'pointer';
            customShowBids.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                showBidHistoryModal();
            });
            }
        }
    }, 0);
}

// Improved polling logic: start only after both containers exist, poll for up to 30 seconds
function waitForWebkulDataAndInit() {
    // console.log('[Custom Auction] Polling for Webkul data...');
    let attempts = 0;
    const maxAttempts = 150; // 30 seconds
    const interval = setInterval(() => {
        attempts++;
        const wkAuction = document.querySelector('#wk-auction');
        const currentBid = wkAuction ? wkAuction.querySelector('#current_bid') : null;
        const minBid = wkAuction ? wkAuction.querySelector('.min_bid_amt') : null;
        // --- Begin: Robust support for ended auctions with final price (span or div) ---
        let finalPriceElem = null;
        if (wkAuction) {
            finalPriceElem = wkAuction.querySelector('.ended_at_div .pa-text-color') ||
                            wkAuction.querySelector('.auction_ended_at');
        }
        // --- End: Robust support for ended auctions with final price ---
        // console.log('[Custom Auction] currentBid:', currentBid ? currentBid.textContent : 'null', '| minBid:', minBid ? minBid.textContent : 'null', '| finalPrice:', finalPriceElem ? finalPriceElem.textContent : 'null');
        if (
            wkAuction && (
                (currentBid && currentBid.textContent.trim()) ||
                (minBid && minBid.textContent.trim()) ||
                (finalPriceElem && finalPriceElem.textContent.trim())
            )
        ) {
            // console.log('[Custom Auction] Webkul data found, initializing custom auction.');
            clearInterval(interval);
            initializeCustomAuction(wkAuction);
        }
        if (attempts > maxAttempts) {
            // console.warn('[Custom Auction] Timed out waiting for Webkul data.');
            clearInterval(interval);
        }
    }, 200);
}

// Separate vault detection system - completely independent
function waitForVaultDataAndInit() {
    let attempts = 0;
    const maxAttempts = 150; // 30 seconds
    const interval = setInterval(() => {
        attempts++;
        const wkAuction = document.querySelector('#wk-auction');
        const vaultContainer = document.querySelector('#swau-vault');
        const auctionContainer = document.querySelector('#swau-auction');
        
        if (vaultContainer && wkAuction) {
            // Check if this is a vault item (no auction elements)
            const hasAuctionElements = wkAuction.querySelector('[id^="auction_"]');
            const hasCurrentBid = wkAuction.querySelector('#current_bid');
            const hasMinBid = wkAuction.querySelector('.min_bid_amt');
            
            if (!hasAuctionElements && !hasCurrentBid && !hasMinBid) {
                clearInterval(interval);
                
                // Clear the auction loading state if it exists
                if (auctionContainer) {
                    auctionContainer.innerHTML = '';
                }
                
                initializeCustomAuction(wkAuction);
            }
        }
        
        if (attempts > maxAttempts) {
            clearInterval(interval);
        }
    }, 200);
}

// DOMContentLoaded logic: only start polling after both containers exist
document.addEventListener('DOMContentLoaded', function() {
    // console.log('[Custom Auction] DOMContentLoaded');
    function tryStartPolling() {
        const swauAuction = document.querySelector('#swau-auction');
        const swauVault = document.querySelector('#swau-vault');
        const wkAuction = document.querySelector('#wk-auction');
        
        // Only proceed if we have the required containers AND we're on a product page
        if ((swauAuction || swauVault) && wkAuction) {
            // Show loading state immediately
            if (swauAuction) {
            swauAuction.innerHTML = `
                <div class="swau-loading-state">
                    <div class="swau-loading-spinner"></div>
                </div>
            `;
            } else if (swauVault) {
                swauVault.innerHTML = `
                    <div class="swau-loading-state">
                        <div class="swau-loading-spinner"></div>
                    </div>
                `;
            }
            
            // Start the original auction system (unchanged)
            waitForWebkulDataAndInit();
            
            // Start the separate vault system (completely independent)
            waitForVaultDataAndInit();
        } else if (swauAuction || swauVault) {
            // If we have auction containers but no wk-auction, try again in 200ms
            setTimeout(tryStartPolling, 200);
        }
        // If no auction containers exist at all, don't do anything (e.g., homepage)
    }
    tryStartPolling();
});

function isWebkulAuctionReady(wkAuction) {
    // Check for required data elements and that they have content
    const currentBid = wkAuction.querySelector('#current_bid');
    const minBid = wkAuction.querySelector('#min_bid_amount');
    return currentBid && currentBid.textContent.trim() && minBid && minBid.value.trim();
}

function observeWebkulAuctionData(wkAuction) {
    // console.log('[Custom Auction] Observing #wk-auction for data population');
    const dataObserver = new MutationObserver(() => {
        if (isWebkulAuctionReady(wkAuction)) {
            // console.log('[Custom Auction] Webkul auction data is now ready. Initializing custom auction.');
            initializeCustomAuction(wkAuction);
            dataObserver.disconnect();
        }
    });
    dataObserver.observe(wkAuction, { childList: true, subtree: true, characterData: true });
} 